import type { TutorialPageDef } from '../types';

export const adsImageTutorials: TutorialPageDef[] = [
  {
    key: 'ads-banner',
    label: 'バナー広告',
    paths: ['/ads/banner'],
    steps: [
      {
        target: 'ads-banner-product-select',
        title: '商品を選ぶ',
        body: '登録済みの商品を選ぶと、AIが商品情報から画像案を作成します。',
      },
      {
        target: 'ads-banner-style',
        title: 'デザインを決める',
        body: '見本からスタイルを選ぶと、バナーの見た目の方向性を決められます。選ばなければ商品に合わせて自動で選びます。',
      },
      {
        target: 'ads-banner-generate',
        title: '枚数を選んで生成',
        body: '画像サイズと枚数を確認したら、このボタンで生成を開始します。',
      },
      {
        target: 'ads-banner-results',
        title: '生成結果を確認',
        body: '進み具合と、これまでに作ったバナーの一覧をここで確認できます。',
      },
    ],
  },
  {
    key: 'ads-banner-ab-tests',
    label: 'オートバナーABテスト',
    paths: ['/ads/banner-ab-tests'],
    steps: [
      {
        target: 'ads-banner-ab-tests-intro',
        title: 'オートバナーABテストとは',
        body: '複数の候補バナーを比較し、選ばれやすい1枚をAIが見つけます。',
      },
      {
        target: 'ads-banner-ab-tests-table',
        title: 'テスト一覧',
        body: '候補・推奨バナー・選ばれた割合を確認できます。行から詳細に進めます。',
      },
    ],
  },
  {
    key: 'ads-banner-ab-test-result',
    label: 'バナーABテスト（結果）',
    paths: ['/ads/banner-ab-tests/:id'],
    steps: [
      {
        target: 'ads-banner-ab-tests-summary',
        title: 'テストの概要',
        body: '仮想顧客数・候補枚数・消費クレジットなど、条件をここで確認できます。',
      },
      {
        target: 'ads-banner-ab-tests-ranking',
        title: '結果と推奨バナー',
        body: '各候補の勝敗と選ばれた割合から、推奨バナーが分かります。',
      },
    ],
  },
  {
    key: 'ads-carousel',
    label: 'カルーセル制作',
    paths: ['/ads/carousel'],
    steps: [
      {
        target: 'ads-carousel-product-select',
        title: '商品を選ぶ',
        body: '登録済みの商品を選ぶと、複数枚で1つのストーリーを作れます。',
      },
      {
        target: 'ads-carousel-structure',
        title: '構成と枚数を決める',
        body: '構成テンプレート・枚数・画像サイズをここで設定します。',
      },
      {
        target: 'ads-carousel-generate',
        title: 'カルーセルを生成',
        body: '設定を確認したら、このボタンで生成を開始します。',
      },
      {
        target: 'ads-carousel-results',
        title: '生成結果を確認',
        body: '進み具合と、これまでに作ったカルーセルの一覧をここで確認できます。',
      },
    ],
  },
  {
    key: 'ads-manga',
    label: '漫画広告',
    paths: ['/ads/manga'],
    steps: [
      {
        target: 'ads-manga-product-select',
        title: '商品を選ぶ',
        body: '登録済みの商品を選ぶと、AIが漫画のストーリー構成を作成します。',
      },
      {
        target: 'ads-manga-style',
        title: 'スタイルを選ぶ',
        body: '漫画のタッチ・構図の方向性を、見本から選べます。',
      },
      {
        target: 'ads-manga-generate',
        title: 'ストーリーを生成',
        body: 'このボタンでストーリー構成を作成します。内容はあとで編集できます。',
      },
      {
        target: 'ads-manga-results',
        title: '生成した漫画一覧',
        body: '過去に作成した漫画をここから確認・ダウンロードできます。',
      },
    ],
  },
  {
    key: 'ads-lp',
    label: 'LP制作',
    paths: ['/ads/lp'],
    steps: [
      {
        target: 'ads-lp-product-select',
        title: '商品を選ぶ',
        body: '登録済みの商品を選ぶと、商品情報が自動で入ります。',
      },
      {
        target: 'ads-lp-mode',
        title: '見せ方を選ぶ',
        body: '文章中心か画像中心か、LPページの見せ方を選べます。',
      },
      {
        target: 'ads-lp-generate',
        title: '商品理解から始める',
        body: 'このボタンでAIが商品を理解し、6段階の制作を開始します。',
      },
      {
        target: 'ads-lp-results',
        title: '制作中・保存済みのLP',
        body: '作成済みのLPをここから開いて続きを編集できます。',
      },
    ],
  },
];
